
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/code-login",
      function () {
        return require("private-next-pages/code-login/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/code-login"])
      });
    }
  